import React, { useEffect, useState } from "react";

//custom
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
//import axios
import axios from "axios";

//utils
import {
  check_authorized,
  signoutuser_confirm,
  isloginuser,
  get_userseckey,
  getuniquedeviceid,
  signoutuser,
} from "../../utils/Helper/CheckAuth";
import CallURL from "../../utils/API/CallURL";
import {
  showLoading,
  stopLoading,
  sent_clean_var,
  onlynumber,
  fun_input_focus,
} from "../../utils/Helper/JSHelper";

function CourseCard(props) {
  //props
  const { afteradd, edit_add, is_admin, item_info } = props;

  //const variable
  const [course_id, set_course_id] = useState(
    edit_add == "edit" ? item_info.course_id : ""
  );
  const [course_seq, set_course_seq] = useState(
    edit_add == "edit" ? item_info.course_seq : ""
  );
  const [course_name, set_course_name] = useState(
    edit_add == "edit" ? item_info.course_name : ""
  );
  const [course_textcolor, set_course_textcolor] = useState(
    edit_add == "edit" ? item_info.course_textcolor : "#ffffff"
  );
  const [course_backcolor, set_course_backcolor] = useState(
    edit_add == "edit" ? item_info.course_backcolor : "#f50057"
  );
  const [couse_sts, set_couse_sts] = useState(
    edit_add == "edit" ? item_info.couse_sts : ""
  );
  const [updatetime, set_updatetime] = useState(
    edit_add == "edit" ? item_info.updatetime : ""
  );
  const [entrytime, set_entrytime] = useState(
    edit_add == "edit" ? item_info.entrytime : ""
  );

  //extra variable
  const [is_edit_show, set_is_edit_show] = useState(false);

  //action on user card
  //add item
  function add_edit_item() {
    if (course_seq == "") {
      alert("Enter Course Sequence");
      fun_input_focus(course_id + "frm_course_seq");
    } else if (course_name.trim() == "") {
      alert("Enter Course Name");
      fun_input_focus(course_id + "frm_course_name");
    } else {
      //showLoading
      showLoading();
      // Create an object of formData
      const formData = new Object();
      // Update the formData object
      formData.secuserkey = get_userseckey();
      formData.deviceid = getuniquedeviceid();
      //extra variable
      formData.edit_add = edit_add;
      formData.course_id = course_id;
      formData.course_seq = course_seq;
      formData.course_name = sent_clean_var(course_name.trim());
      formData.course_textcolor = course_textcolor;
      formData.course_backcolor = course_backcolor;
      // Send formData object
      axios
        .post(CallURL.add_edit_course, formData)
        .then((response) => {
          //stopLoading
          stopLoading();
          //console.log(response);
          //alert(response.data.apires);
          if (response.data.apires == "unauthorized") {
            //make logout
            signoutuser();
          } else if (response.data.apires == "success") {
            if (edit_add == "add") {
              afteradd();
              //reset data
              set_course_seq("");
              set_course_name("");
            } else if (edit_add == "edit") {
              load_item();
              set_is_edit_show(false);
            }
          } else if (response.data.apires == "duplicate") {
            alert("This course name already present.");
          } else {
            alert("Something went wrong. Try again.");
          }
        })
        .catch((error) => {
          //stopLoading
          stopLoading();
          console.log(error);
          alert("Something went wrong. Try again.");
        });
    }
  }
  //load_course
  function load_item() {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    //extra authorized user
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.course_id = course_id;
    // Send formData object
    axios
      .post(CallURL.load_course, formData)
      .then((response) => {
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "success") {
          //set item
          var rows = response.data.rows[0];
          set_course_id(rows.course_id);
          set_course_seq(rows.course_seq);
          set_course_name(rows.course_name);
          set_course_textcolor(rows.course_textcolor);
          set_course_backcolor(rows.course_backcolor);
          set_couse_sts(rows.couse_sts);
          set_updatetime(rows.updatetime);
          set_entrytime(rows.entrytime);
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        console.log(error);
        stopLoading();
        alert("Something went wrong. Try again.");
      });
  }
  //change_status
  function change_status(status) {
    //showLoading
    showLoading();
    // Create an object of formData
    const formData = new Object();
    // Update the formData object
    formData.secuserkey = get_userseckey();
    formData.deviceid = getuniquedeviceid();
    //extra variable
    formData.course_id = course_id;
    formData.status = status;
    // Send formData object
    axios
      .post(CallURL.edit_course_status, formData)
      .then((response) => {
        //stopLoading
        stopLoading();
        //console.log(response);
        //alert(response.data.apires);
        if (response.data.apires == "unauthorized") {
          //make logout
          signoutuser();
        } else if (response.data.apires == "success") {
          load_item();
        } else {
          alert("Something went wrong. Try again.");
        }
      })
      .catch((error) => {
        //stopLoading
        stopLoading();
        console.log(error);
        alert("Something went wrong. Try again.");
      });
  }

  //validate data
  function handle_enter_sequence(e) {
    if (onlynumber(e, 3)) {
      set_course_seq((course_seq) => e.target.value);
    }
  }

  return (
    <>
      {(() => {
        const return_text_card = [];
        if (
          (edit_add == "add" && is_admin == "yes") ||
          (is_edit_show && edit_add == "edit" && is_admin == "yes")
        ) {
          return_text_card.push(
            <div className="div_item z-depth-0">
              Course Sequence
              <input
                type="text"
                placeholder="Course Sequence"
                id={course_id + "frm_course_seq"}
                name={course_id + "frm_course_seq"}
                value={course_seq}
                onChange={(e) => {
                  handle_enter_sequence(e);
                }}
                autoComplete="off"
              />
              Course Name
              <input
                type="text"
                placeholder="Course Name"
                id={course_id + "frm_course_name"}
                name={course_id + "frm_course_name"}
                value={course_name}
                onChange={(e) => {
                  set_course_name(e.target.value);
                }}
                autoComplete="off"
              />
              Course Text Color{" "}
              <input
                type="color"
                placeholder="Course Text Color"
                value={course_textcolor}
                onChange={(e) => {
                  set_course_textcolor(e.target.value);
                }}
              />
              <br />
              Course Background Color{" "}
              <input
                type="color"
                placeholder="Course Background Color"
                value={course_backcolor}
                onChange={(e) => {
                  set_course_backcolor(e.target.value);
                }}
              />
              <br />
              <br />
              <a
                className="btn green"
                style={{ width: edit_add == "add" ? "100%" : "50%" }}
                onClick={add_edit_item}
              >
                <b>{edit_add == "add" ? "Add" : "Save"} Course</b>
              </a>
              {edit_add == "edit" ? (
                <a
                  className="btn red"
                  style={{ width: "50%" }}
                  onClick={() => {
                    load_item();
                    set_is_edit_show(false);
                  }}
                >
                  <b>Close</b>
                </a>
              ) : (
                ""
              )}
            </div>
          );
        }
        if (edit_add == "edit" && !is_edit_show) {
          return_text_card.push(
            <div>
              <div className="center">
                {(() => {
                  const return_text = [];
                  if (is_admin == "yes") {
                    return_text.push(
                      <font
                        className="font_sub_small_content_card"
                        style={{
                          color: "black",
                          backgroundColor: "#ffffff",
                          cursor: "pointer",
                        }}
                        onClick={() => set_is_edit_show(true)}
                      >
                        <hr />
                        &nbsp;
                        <i className="fa fa-pencil fa-lg" /> Edit Course{" "}
                        <br />
                      </font>
                    );
                    if (couse_sts == "1") {
                      return_text.push(
                        <font
                          className="font_sub_small_content_card"
                          style={{ color: "green", backgroundColor: "#ffffff" }}
                        >
                          <i className="fa fa-check fa-lg" /> Active Course{" "}
                          <a
                            className="btn-floating z-depth-1 red"
                            onClick={() => change_status("0")}
                            style={{ zIndex: "0" }}
                          >
                            <i className="fa fa-close"></i>
                          </a>
                        </font>
                      );
                    }
                    if (couse_sts == "0") {
                      return_text.push(
                        <font
                          className="font_sub_small_content_card"
                          style={{ color: "red", backgroundColor: "#ffffff" }}
                        >
                          <i className="fa fa-close fa-lg" /> Deactivated Course{" "}
                          <a
                            className="btn-floating z-depth-1 green"
                            onClick={() => change_status("1")}
                            style={{ zIndex: "0" }}
                          >
                            <i className="fa fa-check"></i>
                          </a>
                        </font>
                      );
                    }
                  }
                  return return_text;
                })()}
              </div>
              <Link
                to={"/course/" + course_id}
                style={{ color: course_textcolor }}
              >
                <div
                  className="div_item_card z-depth-0 center"
                  style={{
                    color: course_textcolor,
                    backgroundColor: course_backcolor,
                  }}
                >
                  <font className="font_sub_title_content_card">
                    {course_seq}
                  </font>
                  <br />
                  <font className="font_sub_title_content_card">
                    {course_name}
                  </font>
                  <br />
                </div>
              </Link>
            </div>
          );
        }
        return return_text_card;
      })()}
    </>
  );
}

export default CourseCard;
